module.exports = __webpack_public_path__ + "img/lijiqiao.d8b1e16e.jpg";